import React from 'react'
import { useNavigate } from 'react-router-dom'
import { RoutesManager } from 'utils/routing/routesManager'
import { ContentGroup, DataGrid, EmptyState } from '@ketch-com/deck'

// assets
import { ReactComponent as EmptyStateIcon } from 'assets/icons/emptyState/EmptyStateDocuments.svg'
import { Box } from '@mui/material'
import { documentsGridColumns } from './utils/purposesTabDocumentsUtils'
import { usePurposeViewContext } from 'pages/policyCenter/purposes/view/context/PurposeViewContext'

export const PurposesTabDocuments: React.FC = () => {
  const { purpose } = usePurposeViewContext()
  const policyDocuments = purpose?.policyDocuments || []
  const navigate = useNavigate()

  return (
    <>
      <Box mb={4}>
        <ContentGroup title="Associated Documents" titleVariant="h3" variant="inner-page-header" />
      </Box>
      {!policyDocuments?.length ? (
        <Box display="flex" alignItems="center" justifyContent="center" padding={6}>
          <EmptyState
            title="There are no associated documents for this purpose"
            customIcon={<EmptyStateIcon />}
            subTitle="Link a document to this purpose to populate this section!"
            primaryButtonTitle="Link Document"
            primaryButtonProps={{
              size: 'large',
              onClick: () => {
                navigate(RoutesManager.policyCenter.policyDocuments.root.getURL())
              },
            }}
          />
        </Box>
      ) : (
        <DataGrid
          sx={{
            padding: 'unset',
            height: 'auto',
          }}
          autosizeOnMount
          columns={documentsGridColumns}
          disableChildrenSorting
          disableColumnMenu
          disableColumnPinning
          disableColumnReorder
          disableColumnResize
          disableRowHoverStates
          disableRowSelectionOnClick
          getRowId={row => row.code}
          hideFooter
          rows={policyDocuments}
          getRowHeight={() => 'auto'}
        />
      )}
    </>
  )
}
